import Checkbox from "common/components/ui/Checkbox";
import {
  DropdownMenuCheckbox,
  DropdownMenuItem,
} from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { ACCOUNTS_FILTERS } from "../constants";

import type { AccountSearchParams } from "../types";

export default function AccountFilterOptions<
  SearchParamsKey extends keyof AccountSearchParams,
>({
  searchParamsKey,
  searchParams,
  setSearchParams,
}: {
  searchParamsKey: SearchParamsKey;
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");

  function toggleParam(
    optionKey: AccountSearchParams[SearchParamsKey][number],
    isChecked: boolean,
  ) {
    const updatedParams = isChecked
      ? searchParams[searchParamsKey].filter(
          (selectedParam) => selectedParam !== optionKey,
        )
      : [...searchParams[searchParamsKey], optionKey];

    setSearchParams({
      ...searchParams,
      [searchParamsKey]: updatedParams,
    });
  }

  return typedObjectEntries(ACCOUNTS_FILTERS[searchParamsKey].options).map(
    ([optionKey, label]) => {
      const isChecked = searchParams[searchParamsKey].includes(
        optionKey as never,
      );

      if (isDesktop) {
        return (
          <DropdownMenuItem
            key={optionKey}
            onSelect={() =>
              setSearchParams({
                ...searchParams,
                [searchParamsKey]: [optionKey],
              })
            }
          >
            <DropdownMenuCheckbox
              isChecked={isChecked}
              onCheckedChange={() => toggleParam(optionKey, isChecked)}
            />
            {label}
          </DropdownMenuItem>
        );
      }
      return (
        <button
          key={optionKey}
          type="button"
          onClick={() => toggleParam(optionKey, isChecked)}
          className="flex items-center p-2 gap-x-1.5 text-button-sm"
        >
          <Checkbox isStyleOnly checked={isChecked} />
          {label}
        </button>
      );
    },
  );
}
